const confirmBlockToggle = (mode) => {
  const confirmBody = document.querySelector('body')
  const confirmBlock = document.querySelector('.confirm__block')
  const confirmOverlay = document.querySelector('.confirm__overlay')

  if( mode === 'show' ) {
    if( confirmBody ) {
      confirmBody.classList.add('confirm-visible')
    }

    if( confirmOverlay ) {
      confirmOverlay.classList.add('visible')
    }

    if( confirmBlock ) {
      confirmBlock.classList.add('visible')
    }
  }
  else {
    if( confirmBody ) {
      confirmBody.classList.remove('confirm-visible')
    }

    if( confirmOverlay ) {
      confirmOverlay.classList.remove('visible')
    }

    if( confirmBlock ) {
      confirmBlock.classList.remove('visible')
    }
  }
}

export {
  confirmBlockToggle,
}
